import html from "../../../img/html5-svgrepo-com.svg";
import css from "../../../img/css3-svgrepo-com.svg";
import javascript from "../../../img/javascript-svgrepo-com.svg";
import node from "../../../img/node-js-svgrepo-com.svg";
import express from "../../../img/express-svgrepo-com.svg";
import mongodb from "../../../img/mongodb-svgrepo-com.svg";
import react from "../../../img/react-svgrepo-com.svg";
import redux from "../../../img/redux-svgrepo-com.svg";
import jwt from "../../../img/jsonwebtokens-svgrepo-com.svg";
import bootstrap from "../../../img/bootstrap-fill-svgrepo-com.svg";
import fontawesome from "../../../img/fontawesome-svgrepo-com.svg";
import trello from "../../../img/trello-svgrepo-com.svg";
import github from "../../../img/github-svgrepo-com.svg";
import vercel from "../../../img/vercel-fill-svgrepo-com.svg";

export const techList = [
  {
    id: 1,
    title: "HTML5",
    icon: html,
  },
  {
    id: 2,
    title: "CSS3",
    icon: css,
  },
  {
    id: 3,
    title: "JavaScript",
    icon: javascript,
  },

  {
    id: 5,
    title: "Node.js",
    icon: node,
  },
  {
    id: 6,
    title: "Express.js",
    icon: express,
  },
  {
    id: 7,
    title: "MongoDB",
    icon: mongodb,
  },
  {
    id: 8,
    title: "React.js",
    icon: react,
  },
  {
    id: 9,
    title: "Redux.js",
    icon: redux,
  },
  {
    id: 10,
    title: "JWT",
    icon: jwt,
  },
  {
    id: 11,
    title: "Bootstrap",
    icon: bootstrap,
  },
  {
    id: 12,
    title: "Font Awesome",
    icon: fontawesome,
  },
  {
    id: 13,
    title: "Trello",
    icon: trello,
  },
  {
    id: 14,
    title: "GitHub",
    icon: github,
  },
  {
    id: 15,
    title: "Vercel",
    icon: vercel,
  },
];
